const generateNarrativeFromSummaryOfFindingsTable = (tableDataState, netEffectPointEstimate, netEffectEstimate) => {
    if (!tableDataState || !tableDataState.Labels ||
        Object.keys(tableDataState.Labels).length === 0) {
        return null;
    }
    let innerDiv = "<table><tr>";
    for (const label of Object.keys(tableDataState.Labels)) {
        innerDiv += "<th>" + label + "</th>";
    }
    innerDiv += "</tr>";
    if (tableDataState.Data && Object.keys(tableDataState.Data).length > 0) {
        for (const entry of Object.keys(tableDataState.Data)) {
            innerDiv += "<tr>";
            if (tableDataState.Data[entry]["REPLACEROW"]) {
                innerDiv += "<td colSpan={8}>" + tableDataState.Data[entry]["REPLACEROW"] + "</td>";
            } else {
                for (const item of Object.keys(tableDataState.Data[entry])) {
                    innerDiv += "<td>";
                    innerDiv += tableDataState.Data[entry][item];
                    innerDiv += "</td>";
                }
            }
            innerDiv += "</tr>";
        }
    }
    innerDiv += "</table>";
    if (netEffectPointEstimate) {
        innerDiv += "<p><b>Net Effect Point Estimate = " + netEffectPointEstimate + "</b></p>";
    }
    if (netEffectEstimate) {
        innerDiv += "<p><b>Net Effect Estimate = " + netEffectEstimate + "</b></p>";
    }
    return {
        "status": "generated",
        "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + innerDiv + "</div>"
    };
};

export default generateNarrativeFromSummaryOfFindingsTable;